module.exports = __webpack_public_path__ + "static/icon_color_bike_nag-1c6941b2248772422609efca90129595.png";